export default "__VITE_ASSET__adb6d657__"